import { render, staticRenderFns } from "./FormAdditionalCost.vue?vue&type=template&id=d6bf623c&scoped=true"
import script from "./FormAdditionalCost.vue?vue&type=script&lang=js"
export * from "./FormAdditionalCost.vue?vue&type=script&lang=js"
import style0 from "./FormAdditionalCost.vue?vue&type=style&index=0&id=d6bf623c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bf623c",
  null
  
)

export default component.exports